import { observable, action, makeObservable } from 'mobx'
import { superAxiosRequest } from 'axiosApi'

class UserStore {
  avatar = null
  userId = null

  constructor() {
    makeObservable(this, {
      avatar: observable,
      userId: observable,
      setAvatar: action,
      setUserId: action,
      fetchAvatar: action,
    })
  }

  setAvatar(newAvatar) {
    this.avatar = newAvatar
  }

  setUserId(id) {
    this.userId = id
  }

  async fetchAvatar() {
    const dataStorage = localStorage.getItem('ud')
    const profile = JSON.parse(dataStorage)
    const role = profile?.user_data?.groups[0]?.name
    const linkProfile = role === 'clients' ? `clients` : `employers_detail`

    if (!this.userId) return

    const response = await superAxiosRequest({
      method: 'get',
      link: `accounts/${linkProfile}/${this.userId}`,
    })

    this.setAvatar(response?.data?.profile?.avatar)
  }
}

export default new UserStore()
